<div class="wsd-dashboard-search">
  <div class="content-container">
    <h1>{{ 'MAIN_DASHBOARD.TITLE_LABEL' | translate }}</h1>
    <div class="ui-g">
      <div class="ui-g-4 show-on-desktop">
        <label>{{ 'DASHBOARD.SHORTCUTS' | translate }}</label>
      </div>
      <div class="ui-g-8 show-on-desktop">
        <span class="title">
          <label>{{ 'DASHBOARD.SEARCH_LABEL' | translate }}</label>
        </span>
      </div>
      <div class="ui-g-offset-4 ui-g-4 ui-sm-offset-0 ui-sm-12">
        <input type="text" pInputText maxlength="50"
               [(ngModel)]="whoWhatSearch"
               placeholder="{{ 'DASHBOARD.WHAT_WHO_PLACEHOLDER' | translate }}"
               (keyup)="search()">
      </div>
      <div class="ui-g-4 ui-sm-12">
        <input type="text" pInputText maxlength="50"
               [(ngModel)]="whereSearch"
               placeholder="{{ 'DASHBOARD.WHERE_PLACEHOLDER' | translate }}"
               (keyup)="search()">
      </div>
    </div>
  </div>
</div>

<div class="content-container wsd-dashboard">
  <div class="ui-g">
    <div class="ui-g-4 show-on-desktop">
      <div class="wsd-shortcuts">
        <div *ngIf="user?.organization?.id">
          <label>{{ 'DASHBOARD.QUICK_SEARCH' | translate }}</label>
          <a [routerLink]="['/organizations', user?.organization?.id, 'detail']">
            My NSO
          </a>
        </div>
        <wsd-exports [filter]="{who: whoWhatSearch, where: whereSearch, filters: filter, sortBy: sortBy}"></wsd-exports>
      </div>
    </div>
    <div class="ui-g-8 ui-sm-12">
      <div class="ui-g m-b-0">
        <div class="ui-g-12 m-t-15">
          <wsd-filter-bar
            [filter]="filter"
            [isAuthenticated]="isAuthenticated"
            (onChange)="search()">
          </wsd-filter-bar>
        </div>
        <div class="ui-g-6">
          <div class="results-label">
            <label class="wsd-dashboard-results-label">
              {{ 'DASHBOARD.RESULTS_LABEL' | translate:{count: data?.totalElements || 0} }}
            </label>

            <p-button *ngIf="showClearBtn()"
                      styleClass="clear-button"
                      label="{{ 'DASHBOARD.CLEAR_BTN_LABEL' | translate }}"
                      (click)="clear()"
                      icon="fa fa-times">
            </p-button>
          </div>
        </div>
        <div class="ui-g-6 m-t-20">
          <label>{{ 'DASHBOARD.SORT_LABEL' | translate }}</label>
          <p-dropdown [options]="sortOptions"
                      (onChange)="search()"
                      [(ngModel)]="sortBy">
          </p-dropdown>
        </div>
      </div>
      <div class="ui-g-12 results-container">
        <div *ngIf="data?.totalElements">
          <p-dataView [value]="data?.content"
                      [paginator]="true"
                      [lazy]="true"
                      paginatorPosition="bottom"
                      (onLazyLoad)="onPageChange($event)"
                      [totalRecords]="data?.totalElements"
                      [rows]="pageSize">
            <p-header></p-header>
            <ng-template let-record pTemplate="listItem">
              <div *ngIf="!record.name" class="wsd-result show-on-desktop">
                <div class="title">{{ record.appointment }}</div>
                <div [routerLink]="['/persons', record.id, 'detail']" class="name pointer">
                  {{ record.title }} {{ record.suffix }} {{ record.firstName }} {{ record.lastName}}
                </div>
                <a [routerLink]="['/persons', record.id, 'detail']">
                  {{ 'DASHBOARD.PROFILE_BTN_LABEL' | translate }}
                </a>
              </div>
              <div *ngIf="!record.name" class="wsd-result show-on-mobile">
                <a [routerLink]="['/persons', record.id, 'detail']">
                  <div class="title" *ngIf="record.appointment">{{ record.appointment }}</div>
                  <div [routerLink]="['/persons', record.id, 'detail']" class="name pointer">
                    {{ record.title }} {{ record.suffix }} {{ record.firstName }} {{ record.lastName}}
                  </div>
                </a>
              </div>
              <div *ngIf="record.name" class="wsd-result show-on-desktop">
                <div class="title">{{ record.organizationSubtype }}</div>
                <div [routerLink]="['/organizations', record.id, 'detail']" class="name pointer">
                  {{ record.name }}
                </div>
                <div class="location">{{ record.country }} &bull; {{ record.region }}</div>
                <a [routerLink]="['/organizations', record.id, 'detail']">
                  {{ 'DASHBOARD.DETAIL_BTN_LABEL' | translate }}
                </a>
              </div>
              <div *ngIf="record.name" class="wsd-result show-on-mobile">
                <a [routerLink]="['/organizations', record.id, 'detail']">
                  <div class="title">{{ record.organizationSubtype }}</div>
                  <div [routerLink]="['/organizations', record.id, 'detail']" class="name pointer">
                    {{ record.name }}
                  </div>
                  <div class="location" *ngIf="record.country">{{ record.country }} &bull; {{ record.region }}</div>
                </a>
              </div>
            </ng-template>
          </p-dataView>
        </div>
      </div>
    </div>
  </div>

</div>
